import React from "react";
import { ButtonV2 } from "../ButtonV2";
import { Container, ContainerFW } from "../global";
import { Heading } from "../Heading";
import { classNames, conditionallyCreateStyleObj, getContainerClassPerMaxWidth, handleLinkTarget, } from "../../utils";
import { usePageViewStyle } from "../../hooks";
export const RibbonWithOutStatLine = ({ buttonHref, buttonLabel, opensInNewTab = false, linkHref, linkLabel, linkOpensInNewTab, subTitle, title, backgroundColor, backgroundImageUrl, bannerColors, buttonDesign, buttonIsSquareRounded = false, imageUrl, borderRadius, containerMaxWidth, }) => {
    const { isLarge } = usePageViewStyle();
    const linkHrefTarget = handleLinkTarget(linkOpensInNewTab);
    const getContainerBkgrColor = () => (backgroundColor || "inherit");
    const containerBkgrColor = getContainerBkgrColor();
    const containerMaxWidthClass = classNames("", {
        ...(containerMaxWidth && {
            [getContainerClassPerMaxWidth(containerMaxWidth)]: true,
        }),
    });
    const extraRootClass = classNames("", {
        "ribbon-without-stat-line-root--with-square-rounded-btn": buttonIsSquareRounded,
    });
    const getCustomStyleObj = () => conditionallyCreateStyleObj({
        "--banner-bkgr-color": bannerColors?.bannerBkgrColor,
        "--banner-border-color": bannerColors?.bannerBorderColor,
        "--banner-bkgr-image": backgroundImageUrl ? `url(${backgroundImageUrl})` : "",
        "--title-color": bannerColors?.titleColor,
        "--sub-title-color": bannerColors?.subTitleColor,
        "--button-bkgr-color": bannerColors?.buttonBkgrColor,
        "--button-text-color": bannerColors?.buttonTextColor,
        "--button-hover-bkgr-color": bannerColors?.buttonHoverBkgrColor,
        "--button-hover-text-color": bannerColors?.buttonHoverTextColor,
        "--link-color": bannerColors?.linkColor,
        "--border-radius": typeof borderRadius !== "undefined" ? `${borderRadius}px` : ""
    });
    const customStyleObj = getCustomStyleObj();
    const getButtonDesign = () => buttonDesign || "tmx25-square-green-green";
    const buttonDesignValue = getButtonDesign();
    const checkIfMustRenderImage = () => isLarge && imageUrl;
    const mustRenderImage = checkIfMustRenderImage();
    return (React.createElement(ContainerFW, { backgroundColor: containerBkgrColor, className: containerMaxWidthClass },
        React.createElement("div", { className: `ribbon-without-stat-line-root ${extraRootClass}`, style: customStyleObj },
            React.createElement(Container, { className: `g-container--tablet-margins ${containerMaxWidthClass}` },
                React.createElement("div", { className: "ribbon-without-stat-line-root__contentWrapper" },
                    mustRenderImage && React.createElement("img", { src: imageUrl, alt: "" }),
                    React.createElement("div", { className: "ribbon-without-stat-line-root__contentWrapper__textWrapper" },
                        title && (React.createElement(Heading, { design: "h4-semi-bold" },
                            React.createElement("span", { dangerouslySetInnerHTML: {
                                    __html: title,
                                } }))),
                        subTitle && (React.createElement("div", { className: "ribbon-without-stat-line-root__contentWrapper__subtitle", dangerouslySetInnerHTML: {
                                __html: subTitle,
                            } }))),
                    React.createElement("div", { className: "ribbon-without-stat-line-root__contentWrapper__buttonsWrapper" },
                        React.createElement(ButtonV2, { href: buttonHref, design: buttonDesignValue, openInNewTab: opensInNewTab }, buttonLabel),
                        linkLabel && (React.createElement("a", { className: "ribbon-without-stat-line-root__contentWrapper__link", href: linkHref, target: linkHrefTarget }, linkLabel))))))));
};
